import * as React from 'react';
import styles from './index.less';
import { history } from '@@/core/history';
import * as AHooks from 'ahooks';
import { FI18n } from '@freelog/tools-lib';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';

interface FPromptProps {
  watch: boolean;
  title?: string;
  messageText?: string;
  okText?: string;
  cancelText?: string;

  onOk?(locationHref: string): void;

  onCancel?(locationHref: string): void;
}

function FPrompt({
  watch,
  title = FI18n.i18nNext.tAuto('alarm_leave_page_title'),
  messageText = FI18n.i18nNext.tAuto('alarm_leave_page'),
  okText = FI18n.i18nNext.tAuto('btn_leave'),
  cancelText = FI18n.i18nNext.tAuto('btn_cancel'),
  onOk,
  onCancel,
}: FPromptProps) {
  const prompting = React.useRef<boolean>(false);

  React.useEffect(() => {
    if (watch) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = null;
    }
  }, [watch]);

  React.useEffect(() => {
    if (!watch) return;

    const unblock = history.block((update: any) => {
      if (prompting.current) return;
      prompting.current = true;
      const loc = update.location;
      const locationHref: string = loc.pathname + (loc.search || '') + (loc.hash || '');
      handle(locationHref, unblock);
    });

    return () => {
      unblock();
    };
  }, [watch, title, messageText, okText, cancelText, onOk, onCancel]);

  AHooks.useUnmount(() => {
    window.onbeforeunload = null;
  });

  async function handle(locationHref: string, unblock: () => void) {
    const bool: boolean = await fPromiseModalConfirm({
      title: title,
      description: messageText,
      okText: okText,
      cancelText: cancelText,
    });

    if (bool) {
      unblock();
      onOk ? onOk(locationHref) : history.push(locationHref);
    } else {
      onCancel?.(locationHref);
    }
    prompting.current = false;
  }

  return null;
}

export default FPrompt;
